// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-visible"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.5 21.5C13.9974 21.4998 12.5 18 12.5 18C12.5 18 13.9974 14.5023 17.5 14.5C21.0026 14.4977 22.5 18 22.5 18C22.5 18 21.0026 21.5002 17.5 21.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 15H8C5.23858 15 3 17.2386 3 20V21H10.05M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.25 18H17.75M17.5 21.5C13.9974 21.4998 12.5 18 12.5 18C12.5 18 13.9974 14.5023 17.5 14.5C21.0026 14.4977 22.5 18 22.5 18C22.5 18 21.0026 21.5002 17.5 21.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserVisibleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-visible',
    ref,
    icon: element,
  },
));

UserVisibleIcon.displayName = 'UserVisibleIcon';

export default UserVisibleIcon;
